// @flow
import React from 'react';
import { ProductCard } from '@finect/tabular-components/ProductCard';
import { CardInfo } from './partials';

type Props = {
  entity: Object
};

export const ProductInfo = ({ entity }: Props) => (
  <CardInfo padding="15px 12px">
    <ProductCard entity={entity} withLink />
  </CardInfo>
);
